import { ErrorTransformer } from '@rjsf/utils';

export const transformErrors: ErrorTransformer = (errors) => {
  return errors.map((e) => {
    switch (e.name) {
      case 'required':
        return {
          ...e,
          message: `This field is required.`
        };
      case 'enum':
      case 'oneOf':
        return {
          ...e,
          message: `Please select a valid option.`
        };
      case 'maxLength':
        return {
          ...e,
          message: `Maximum ${(e.params as { limit?: number })?.limit} characters.`
        };
      case 'pattern':
        return {
          ...e,
          message: `Invalid format.`
        };
    }
    return e;
  });
};
